 
import Sidebar from './Sidebar';
import Navbar from './Navbar';
 import UserImage from './1.jpg';
import { useState, useEffect } from 'react';

const AddUser = () => {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem('jwt_token');

  const [roles, setRoles] = useState([]);

  useEffect(() => {
      const fetchRoles = async () => {
          const res = await fetch(`${API_BASE_URL}api/getRoleList`, {
              method: 'GET',
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${token}`
              },
          });
          const data = await res.json();
          console.log(data);
          setRoles(Array.isArray(data.data) ? data.data : []);
      };
      fetchRoles();
  }, [API_BASE_URL, token]);

  const [formData, setFormData] = useState({
      role: 'EMPLOYEE',
      fname: '',
      lname: '',
      mobile: '',
      altconno: '',
      email: '',
      emp_code: '',
      gender: 'M',
      profile_image: null // For file upload
  });

  const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevData) => ({
          ...prevData,
          [name]: value,
      }));
  };

  const handleFileChange = (e) => {
      const file = e.target.files?.[0];
      if (file) {
          setFormData((prevData) => ({
              ...prevData,
              profile_image: file,
          }));
      }
  };

  const handleSubmit = async (e) => {
      e.preventDefault();
      const { fname, lname, mobile, email, emp_code, gender, role, profile_image } = formData;

      // Simple validation
      if (!fname || !lname  || !emp_code || !role) {
          alert(JSON.stringify(formData, null, 2));
          return;
      }

      const form = new FormData();
      form.append('fname', fname);
      form.append('lname', lname);
      form.append('mobile', mobile);
      form.append('email', email);
      form.append('emp_code', emp_code);
      form.append('gender', gender);
      form.append('role', role);
      if (profile_image) {
          form.append('profile_image', profile_image);
      }

      try {
          const res = await fetch(`${API_BASE_URL}api/addUser`, {
              method: 'POST',
              headers: {
                  'Authorization': `Bearer ${token}`,
              },
              body: form,
          });

          const data = await res.json();
          console.log(data);
          if (data.STATUS) {
              alert("User added successfully.");
              window.location.href = "/users_list";
          } else {
              alert(data.message || "Error adding user.");
          }
      } catch (error) {
          console.error('Error adding user:', error);
      }
  };

  return (
    <div className="wrapper">
      <Sidebar />
      <main className="main-content content-page ">
        <div className="position-relative ">
          <Navbar /></div>
        <div className="content-inner container-fluid pb-0" id="page_layout">
          <div>
            <div className="row">
              {/* <div className="col-sm-12">
                <div className="row"> */}
                  
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-lg-3">
                            <div className="card">
                                <div className="card-header d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">Add User</h4>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div>
                                        <div className="form-group">
                                            <div className="container d-flex flex-column align-items-center py-5">
                                                <div className="text-center">
                                                    <img
                                                        className="profile-pic img-fluid rounded-circle mb-3"
                                                        src={UserImage}
                                                        alt="profile-pic"
                                                        style={{ width: 150, height: 150, objectFit: 'cover' }}
                                                    />
                                                    <div>
                                                        <button
                                                            className="btn btn-primary rounded-1"
                                                            type="button"
                                                            onClick={() => document.getElementById('file-upload')?.click()}
                                                        >
                                                            Profile Upload
                                                        </button>
                                                        <input
                                                            id="file-upload"
                                                            type="file"
                                                            accept="image/*"
                                                            className="d-none"
                                                            onChange={handleFileChange}
                                                            title="Upload Profile Image"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label>User Role:</label>
                                            <label htmlFor="role">User Role:</label>
                                            <select
                                                id="role"
                                                name="role"
                                                className="form-control form-control-sm my-2"
                                                value={formData.role}
                                                onChange={handleInputChange}
                                            >
                                                {roles.filter(role => role.role.toLowerCase() !== 'doctor').map((role) => (
                                                    <option key={role.role_id} value={role.role}>
                                                        {role.role}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-9">
                            <div className="card">
                                <div className="card-header d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">New User Information</h4>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="new-user-info">
                                        <div className="row">
                                            <div className="form-group col-md-6">
                                                <label htmlFor="fname">First Name:</label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm my-2"
                                                    id="fname"
                                                    name="fname"
                                                    value={formData.fname}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label htmlFor="lname">Last Name:</label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm my-2"
                                                    id="lname"
                                                    name="lname"
                                                    value={formData.lname}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label htmlFor="emp_code">BMID:</label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm my-2"
                                                    id="emp_code"
                                                    name="emp_code"
                                                    value={formData.emp_code}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label htmlFor="gender">Gender</label>
                                                <select
                                                    className="form-control form-control-sm my-2"
                                                    id="gender"
                                                    name="gender"
                                                    value={formData.gender}
                                                    onChange={handleInputChange}
                                                >
                                                    <option value="M">Male</option>
                                                    <option value="F">Female</option>
                                                </select>
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label htmlFor="email">Email Id:</label>
                                                <input
                                                    type="email"
                                                    className="form-control form-control-sm my-2"
                                                    id="email"
                                                    name="email"
                                                    value={formData.email}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label htmlFor="mobile">Mobile Number:</label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm my-2"
                                                    id="mobile"
                                                    name="mobile"
                                                    value={formData.mobile}
                                                    onChange={handleInputChange}
                                                    
                                                />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label htmlFor="mobile">Role:</label>
                                                <select
                                                    className="form-control form-control-sm my-2"
                                                    id="role"
                                                    name="role"
                                                    value={formData.role}
                                                    onChange={handleInputChange}>
                                                    {roles.filter(role => role.role.toLowerCase() !== 'doctor').map((role) => (
                                                        <option key={role.role_id} value={role.role}>
                                                            {role.role}
                                                        </option>
                                                    ))}
                                                    </select>
                                               
                                            </div>
                                        </div>
                                        <div className="d-flex gap-2">
                                            <button type="button" className="btn btn-sm btn-danger-subtle" onClick={() => window.history.back()}>
                                                Cancel
                                            </button>
                                            <button type="submit" className="btn btn-sm btn-primary-subtle">Save</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </form>

                

                 
                {/* </div>
              </div> */}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AddUser;
